<template>
  <div class="protag" :class="[internal && 'protag2']">
    <div v-if="expire_day" class="pro-member flex-center" :class="[now < expire_day ? 'orange' : 'grey', full && 'full']">
      <span class="pro">PRO</span>
      <span class="pro-time">
        {{ expire_day | parseTime('{y}/{m}/{d}') }}{{now < expire_day ? '到期' : '已过期'}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProTag",
  props: {
    expire_day: {
      type: Number,
      default: 0,
    },
    internal: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      now: parseInt(new Date().getTime() / 1000),
    };
  },

  created: function () {
  },
  
  mounted() {},
};
</script>

<style lang="scss" scoped>
.protag {
  .pro-member {
    height: 18px;
    width: 40px;
    line-height: 1;
    border-radius: 30px 30px 30px 10px;
    text-align: center;
    font-size: 12px;
    padding: 0px 5px;
    color: white;
    &.full {
      width: 150px;
      .pro-time {
        display: block;
        border-left: 1px solid white;
      }
    }

    .pro {
      padding: 0 5px;
    }

    .pro-time {
      display: none;
      padding: 0 5px;
    }

    &.orange {
      background-color: rgba(242, 150, 25, 1);
      &:hover {
        width: 150px;

        .pro-time {
          display: block;
          border-left: 1px solid white;
        }
      }
    }

    &.grey {
      background-color: rgba(144, 147, 153, 1);
      &:hover {
        width: 150px;

        .pro-time {
          display: block;
          border-left: 1px solid white;
        }
      }
    }
  }
}
.protag.protag2 {
  .pro-member {
    width: 50px;
    height: 20px;
    line-height: 1;
    border-radius: 30px 30px 30px 10px;
    text-align: center;
    padding: 0px 5px;
    color: white;
    font-size: 12px;
    &.full {
      width: 160px;
      .pro-time {
        display: block;
        border-left: 1px solid white;
      }
    }
    .pro {
      padding: 0 5px;
    }
    .pro-time {
      display: none;
      padding: 0 5px;
    }
    &.orange {
      background-color: rgba(242, 150, 25, 1);
      &:hover {
        width: 160px;
        .pro-time {
          display: block;
          border-left: 1px solid white;
        }
      }
    }

    &.grey {
      background-color: rgba(144, 147, 153, 1);
      &:hover {
        width: 160px;
        .pro-time {
          display: block;
          border-left: 1px solid white;
        }
      }
    }
  }
}
</style>
